module.exports = __webpack_public_path__ + "static/media/Chord-Personalities_Stripes.1fdb81ff.png";